import { useRef } from "react"
import { useTranslation } from "react-i18next"

export const ElegirNombre = ({ setNombre }) => {
  const nombreEl = useRef(null)

  const { t } = useTranslation()

  return (
    <>
      <div className="title pt-4">
        {t(`games.sea_animals.tell_me_your_name`)}
      </div>
      <div id="category-container" className="container-sm container-mini">
        <div className="d-flex justify-content-center align-items-center flex-row">
          <input
            ref={nombreEl}
            type="text"
            style={{ textAlign: "center" }}
            placeholder={t(`games.sea_animals.anonymous`)}
          />
        </div>
        <div className="d-flex justify-content-center align-items-center flex-row">
          <button
            onClick={() => setNombre(nombreEl.current.value)}
            className="btn azul my-3"
          >
            {t(`ui.btns.next`)}
          </button>
        </div>
      </div>
    </>
  )
}
